const doc = [({"en":({"activerecord":({"models":({"log_key":({"one":"Log key", "other":"Log keys"})}), "attributes":({"log_key":({"key":"Key"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;